import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PAYMENT_HISTORY } from "../../settings/APISetting";
import { arrayFilter, output } from "../../settings/themeSettings";
import axiosInstance from "../../config/axiosConfig";



export const fetchPaiments = createAsyncThunk('fetch-paiements', async (params) => {
    try {
        console.log('[DEBUG] fetchPaiments called with params:', params);
        let url = PAYMENT_HISTORY;
        console.log('[DEBUG] Base URL:', url);

        if (params) {
            const { startDate, endDate } = params;
            url += `?startDate=${startDate}&endDate=${endDate}`;
            console.log('[DEBUG] URL with params:', url);
        }

        console.log('[DEBUG] Making request to:', url);
        const response = await axiosInstance.get(url);
        console.log('[DEBUG] Response received:', response.status, response.data);
        
        return response.data;
    } catch (error) {
        console.error("[DEBUG] Error fetching paiements:", error);
        console.error("[DEBUG] Error response:", error.response);
        console.error("[DEBUG] Error status:", error.response?.status);
        console.error("[DEBUG] Error data:", error.response?.data);
        throw error;
    }
});



const paiementsSlice = createSlice({


    name: 'paiements',
    initialState: { paiements: [], fetchPaiementStatus: '' },
    reducers: {

        filterPayments: (state, action) => {
            state.paiements = arrayFilter(new RegExp(action.payload.nail), state.paiements)
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPaiments.fulfilled, (state, action) => {
            console.log('[DEBUG] fetchPaiments fulfilled with payload:', action.payload);

            let placeholder = action.payload;

            if (Array.isArray(placeholder)) {
                console.log('[DEBUG] Processing array of payments:', placeholder.length);
                placeholder.map((paie) => {
                    if (paie.facture) {
                        paie.facture = paie.facture.numeroFacture;
                    }
                    return paie;
                });
                state.paiements = placeholder;
                console.log('[DEBUG] Final payments array set:', state.paiements);
            } else {
                state.paiements = [];
                console.error("[DEBUG] fetchPaiements payload is not an array:", placeholder);
            }

            state.fetchStatus = 'success';
        }).addCase(fetchPaiments.pending, (state, action) => {
            console.log('[DEBUG] fetchPaiments pending');
            state.fetchStatus = 'loading';

        }).addCase(fetchPaiments.rejected, (state, action) => {
            console.log('[DEBUG] fetchPaiments rejected:', action);
            output(action);

            state.fetchStatus = 'error';

        });
    }

});

export default paiementsSlice;